import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { CSSTransition } from "react-transition-group";
import PropTypes from "prop-types";
import {
  makeGetIsCommentIdFirstAfterParentLastVisitSelector,
  makeNewCommentsTextByCommentSelector,
} from "~/store/selectors/selector.comments.jsx";
import NewCommentsSplitter from "./NewCommentsSplitter.jsx";

const NewCommentsSplitterTransition = ({ commentId, ...rest }) => {
  const getIsCommentIdFirstAfterParentLastVisit = useMemo(makeGetIsCommentIdFirstAfterParentLastVisitSelector, []);
  const getNewCommentsText = useMemo(makeNewCommentsTextByCommentSelector, []);

  const isLastNew = useSelector((state) => getIsCommentIdFirstAfterParentLastVisit(state, commentId));
  const text = useSelector((state) => getNewCommentsText(state, commentId));

  return (
    <CSSTransition
      in={isLastNew}
      timeout={150}
      classNames="last-new"
      unmountOnExit
    >
      <NewCommentsSplitter
        {...rest}
        text={text}
      />
    </CSSTransition>
  );
};

NewCommentsSplitterTransition.propTypes = {
  commentId: PropTypes.number,
};

export default NewCommentsSplitterTransition;
